export default __webpack_public_path__ + "static/media/luv1.7a0bd68b.mp3";